import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { myCoursesSsoCreator } from 'store/actionsCreators';

const MyCoursesSso = ({ redirectToMyCourses, history }) => {
  useEffect(() => {
    redirectToMyCourses(history);
  });
  return <></>;
}

MyCoursesSso.propTypes = {
  redirectToMyCourses: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  redirectToMyCourses: (history) => dispatch(myCoursesSsoCreator(history)),
});

export default connect(null, mapDispatchToProps)(MyCoursesSso);